export const PRIMARY_RED = "#e42625";
